import MenuButton from '../components/MenuButton'
import { useGame } from '../contexts/GameContext'

export function InstructionsScreen() {
	const { currentScreen, changeScreen } = useGame()

	return (
		<div
			className={`absolute inset-0 transition-opacity duration-300 ${currentScreen === 'instructions' ? 'opacity-100' : 'pointer-events-none opacity-0'}`}
		>
			<div className="relative h-screen w-full bg-[#28aae1]">
				<img src="./assets/telas/instrucoes_sem_botao_iniciar.svg" alt="Instruções" className="h-full w-full object-contain" />

				<MenuButton
					src="./assets/botoes/botao_fechar.svg"
					alt="Fechar"
					onClick={() => changeScreen('home')}
					title="Voltar para Home"
					className="absolute top-5 right-5 size-10"
				/>

				<MenuButton
					src="./assets/botoes/botao_iniciar.svg"
					alt="Iniciar"
					onClick={() => changeScreen('game')}
					title="Iniciar Jogo"
					className="absolute right-[5%] bottom-[5%] h-12 lg:h-20"
				/>
			</div>
		</div>
	)
}
